export default "__VITE_ASSET__BGBD3UWj__"